import { delay, put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getSecondSsidSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getSecondSsidLoading())
     const response = yield axios.get(
        '/getAdditionalNetworks',
       {
        MAC: rMac
       }
      )
      if (response?.status === 200) {
        yield put(actions.getSecondSsidSuccess(response?.data));
      } else {
        yield put(actions.getSecondSsidFail());
      }
    } catch (error) {
      yield put(actions.getSecondSsidFail());
    }
  }
}

export function* addSecondSsidInfoDetailsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
     let response = {};
      if(action.info.method === 'patch'){
         response = yield axios.patch(
          '/updateAdditionalNetworks',
          {
            rMac: rMac,
            bToken: token,
            enable: action.info.enable,
            encryptionKey: action.info.ssidPassword,
            ssid: action.info.ssid,
            ssidBroadcast: action.info.ssidBroadcast,
            sessionToken: sessionToken
          }
        )
       
        if(response.data.status === 200){
          yield put(actions.setSecondSsidInfoDetails(response.data.message))
          yield put(actions.getSecondSsid());
          yield put(actions.refreshDevices())
        }else{
          yield put(actions.setSecondSsidInfoFailed());
          yield put(actions.setSecondSsidInfoFailedMessage(response.data.message.error.message));
        }
      } else {
         response = yield axios.post(
          '/createAdditionalNetworks',
          {
            rMac: rMac,
            bToken: token,
            enable: action.info.enable,
            encryptionKey: action.info.ssidPassword,
            ssid: action.info.ssid,
            ssidBroadcast: action.info.ssidBroadcast,
            sessionToken: sessionToken
          }
        )
        if(response.data.status === 200){
          yield put(actions.setSecondSsidInfoDetails(response.data.message))
          yield put(actions.getSecondSsid());
        }else{
          yield put(actions.setSecondSsidInfoFailed());
          yield put(actions.setSecondSsidInfoFailedMessage(response.data.message.error.message));
        }
       
      }
      
    } catch (error) {
      yield put(actions.setSecondSsidInfoFailed());
    }
  } else {
    // console.log('NO TOKEN');
    yield put(actions.setSecondSsidInfoFailed());
  }
}

export function* deleteSecondSsidInfoDetailsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const axiosConfig = {
        method: 'delete',
        url: '/deleteAdditionalNetworks',
        params: {
          rMac: rMac,
          sessionToken: sessionToken
        }
      }
      const response = yield axios(axiosConfig);
     
        if(response.status === 200){
          yield put(actions.deleteSecondSsidSuccess(response.message))
          yield put(actions.getSecondSsid());
          yield put(actions.refreshDevices())
        }else{
          yield put(actions.deleteSecondSsidFailed());
        }
       
    } catch (error) {
      yield put(actions.deleteSecondSsidFailed());
    }
  } else {
    // console.log('NO TOKEN');
    yield put(actions.deleteSecondSsidFailed());
  }
}


